// Mock data for Pixend website clone
import andprlogo from '../asset/images/Logos/andprlogo.png'

export const navigationLinks = [
  { name: 'Home', href: '#home' },
  { name: 'Works', href: '#works' },
  { name: 'About', href: '#about' },
  { name: 'Pricing', href: '#pricing' },
  { name: 'Blog', href: '#blog' }
];

export const heroData = {
  label: 'Single Subscription Unlimited Design',
  headline: 'Ideas Born, Digitally Brought Alive',
  ctaText: 'Get Started Now',
  heroImage: 'https://images.unsplash.com/photo-1633356122544-f134324a6cee?w=800&h=600&fit=crop'
};

export const aboutData = {
  label: 'ABOUT US',
  partners: [
    { name: 'HubSpot', logo: 'https://cdn.worldvectorlogo.com/logos/hubspot.svg' }
  ],
  description: 'We have put together a special combination of strategy, marketing, design, and digital expertise, design, and digital expertise.',
  clientLogos: [
    'BOGO', 'Oragene', 'LOCO', 'Ligon', 'Ford', 'BYOM',
    'YOO', 'NK', 'BOGO', 'Oragene', 'LOCO', 'Ligon', 'BYOM'
  ]
};

export const portfolioItems = [
  {
    id: 1,
    title: 'Exploid Game',
    category: 'Mobile App',
    year: '2023',
    image: 'https://images.unsplash.com/photo-1556438064-2d7646166914?w=600&h=400&fit=crop'
  },
  {
    id: 2,
    title: 'Taskify App',
    category: 'Web Design',
    year: '2023',
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&h=400&fit=crop'
  },
  {
    id: 3,
    title: 'Fashion Brand',
    category: 'Branding',
    year: '2024',
    image: 'https://images.unsplash.com/photo-1445205170230-053b83016050?w=600&h=400&fit=crop'
  },
  {
    id: 4,
    title: 'Leardo Ecom',
    category: 'Website Design',
    year: '2023',
    image: 'https://images.unsplash.com/photo-1661956602116-aa6865609028?w=600&h=400&fit=crop'
  }
];

export const services = [
  {
    id: 1,
    title: 'UI/UX Design',
    description: 'We design intuitive and beautiful user interfaces that provide exceptional user experiences, combining creativity with functionality to elevate your digital products.',
    icon: 'Palette'
  },
  {
    id: 2,
    title: 'Web Development',
    description: 'Building responsive, performant, and scalable websites using modern technologies, ensuring fast performance, cross-browser compatibility, and seamless design.',
    icon: 'Code'
  },
  {
    id: 3,
    title: 'App Development',
    description: 'Creating robust, high-performance mobile and web applications, focusing on user experience, efficient coding, and cross-platform compatibility.',
    icon: 'Smartphone'
  },
  {
    id: 4,
    title: 'Digital Marketing',
    description: 'Comprehensive digital marketing solutions, including SEO, social media, content strategy, and paid advertising, to help businesses grow online.',
    icon: 'TrendingUp'
  }
];

export const testimonials = [
  {
    id: 1,
    quote: 'When we first partnered with And PR, we did not just find an agency, we found a team that felt like an extension of our own family. They have handled everything with care and precision: guest list curation, celebrity management, media coverage, influencer collaborations, cross-brand promotions, event execution, and press coordination, all done with the same passion as if these brands were their own. What makes them truly special is not just their professionalism, but their people. They over-deliver, they\'re always there when you need them, and they bring an energy and positivity that makes even the most stressful moments exciting. We are deeply proud and grateful to have And PR with Sneha, Chhavi, and Rishika as part of our journey. Not just for what they\'ve done for our brands, but for how they\'ve done it: with heart, dedication, and a shared sense of pride in every achievement.',
    name: ' Adyaaye and Gavins',
    role: 'Founders',
    avatar: andprlogo
  },
  {
    id: 2,
    quote: 'Working with And PR has been such a game-changer for us. When I decided to switch from my previous PR agency, I was looking for more than just monthly updates and meetings. I wanted a team that truly gets us and works with heart. From day one, Sneha and her team have gone above and beyond. Sneha personally visits us often, and we\'ve built such a genuine, friendly bond. No matter what it is, events, shoots, or any big brand moment, they\'re always there, ready to make it happen. The energy and passion they bring, especially from the younger team members, is just incredible. They\'re now handling two of our brands, and the response we\'ve been getting is amazing. I\'ve already recommended them to friends in the industry.',
    name: 'Shasha Gaba',
    role: 'Founder',
    avatar: 'https://i.pravatar.cc/150?img=5'
  },
  {
    id: 3,
    quote: 'Sneha exemplifies passion, poise, power, positivity, and unparalleled performance. She has earned our trust, transforming what could be just a service into a true partnership. She\'s not just an extension of my team, she embodies leadership, dedication, and excellence at every step. Her influence inspires confidence and drives results beyond expectations.',
    name: 'Pentagon Press LLP',
    role: 'Founder',
    avatar: 'https://i.pravatar.cc/150?img=6'
  },
  {
    id: 4,
    quote: 'I started working with And PR for my upcoming multi-designer store, and I would like to say that the whole And PR team does all their work full of heart. And I love that. Each team member puts in lots of time and effort to make sure there\'s good understanding and the most optimum results in the work being done. They\'re also really warm and approachable, making work fun and easy! Lots of love and growth to And PR always!',
    name: 'Laila Faisal Studio',
    role: 'Founder',
    avatar: 'https://i.pravatar.cc/150?img=7'
  }, {
    id: 5,
    quote: 'And PR is always proactive and approaches every task as if it is their own brand. Their instinct and attention to all the details were spot-on every time. Truly a one-stop destination for all your marketing needs.',
    name: 'Vatsal Exports',
    role: 'Founder',
    avatar: 'https://i.pravatar.cc/150?img=8'
  }
];

export const processSteps = [
  {
    number: '01.',
    title: 'Subscribe',
    description: 'Choose your plan and subscribe to get started with unlimited design requests.'
  },
  {
    number: '02.',
    title: 'Request',
    description: 'Submit your design requests through our simple dashboard anytime you need.'
  },
  {
    number: '03.',
    title: 'Project',
    description: 'Receive your designs within days and request unlimited revisions.'
  }
];

export const pricingData = {
  title: 'Monthly Pack',
  price: '$4,990',
  period: '/month',
  description: 'Unlock unlimited design services with a single all-inclusive subscription. Get access to top-tier design expertise, unlimited revisions, and a space-like unlimited monthly fee.',
  features: [
    'Unlimited Requests',
    'Unlimited Revisions',
    'Unlimited Team Members',
    'Unlimited Storage',
    'Pause or cancel anytime'
  ]
};

export const faqData = [
  {
    id: 1,
    question: 'What is included in the subscription?',
    answer: 'The subscription includes unlimited design requests, unlimited revisions, unlimited team members, unlimited storage, and the flexibility to pause or cancel anytime.'
  },
  {
    id: 2,
    question: 'How long does it take to complete a design?',
    answer: 'Most design requests are completed within 2-3 business days. Complex projects may take longer, but we\'ll keep you updated throughout the process.'
  },
  {
    id: 3,
    question: 'Is there a limit to revisions?',
    answer: 'No, there is no limit to revisions. We\'ll continue refining your design until you\'re completely satisfied with the result.'
  },
  {
    id: 4,
    question: 'Can I cancel my subscription anytime?',
    answer: 'Yes, you can pause or cancel your subscription at any time. There are no long-term contracts or cancellation fees.'
  },
  {
    id: 5,
    question: 'What if I need a custom design outside the plan?',
    answer: 'Our subscription covers most design needs. For highly specialized requests, we can discuss custom solutions that fit your specific requirements.'
  }
];

export const footerData = {
  brandName: 'And PR Agency',
  brandTagline: 'Digital experiences that drive growth — strategy, design, and development under one roof.',
  email: 'contact@andpragency.com',
  phone: '+91 7303885011',
  phoneLink: '+917303885011',
  whatsappNumber: '917303885011',
  address: 'Third floor, D 86, 100 Feet Rd, Chhatarpur Enclave Phase 2, Chattarpur Enclave, Chhatarpur, New Delhi, Delhi 110084',
  sections: [
    {
      title: 'Job Application',
      link: 'contact@andpragency.com'
    },
    {
      title: 'Office Address',
      content: 'Third floor, D 86, 100 Feet Rd, Chhatarpur Enclave Phase 2, Chattarpur Enclave, Chhatarpur, New Delhi, Delhi 110084'
    },
    {
      title: 'Phone Number',
      content: '+91 7303885011'
    }
  ],
  socials: [
    { name: 'Twitter', icon: 'Twitter', url: '#' },
    { name: 'LinkedIn', icon: 'Linkedin', url: '#' },
    { name: 'Instagram', icon: 'Instagram', url: '#' },
    { name: 'Facebook', icon: 'Facebook', url: '#' }
  ],
  copyright: '© 2026 And PR Agency. All Rights Reserved.'
};

export async function submitContactForm(formData) {
  const payload = {
    name: formData.name || '',
    company: formData.company || '',
    email: formData.email || '',
    phone: formData.phone || '',
    message: formData.message || '',
    website: formData.website || '',
    // Use the provided timestamp, or backdate by 10s to pass spam time-checks
    ts: formData.ts || (Date.now() - 10000),
  };

  const response = await fetch('/send.php', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  let data;
  try {
    data = await response.json();
  } catch (err) {
    throw new Error('Invalid response from server.');
  }

  if (!response.ok || !data?.success) {
    throw new Error(data?.message || 'Unable to send your message. Please try again later.');
  }

  return data;
}

export async function submitNewsletterForm(formData) {
  const payload = {
    name: formData.name || '',
    email: formData.email || '',
    website: formData.website || '', // honeypot
    ts: formData.ts || (Date.now() - 10000),
  };

  const response = await fetch('/subscribe.php', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  let data;
  try {
    data = await response.json();
  } catch (err) {
    throw new Error('Invalid response from server.');
  }

  if (!response.ok || !data?.success) {
    throw new Error(data?.message || 'Unable to subscribe. Please try again later.');
  }

  return data;
}
